export default [
  {
    list_class: 'sidebar-item',
    link_class: 'sidebar-link',
    to: '/asset',
    icon_feather: 'box',
    name: 'Create Asset',
    requiresAuth: false,
  },
  {
    list_class: 'sidebar-item',
    link_class: 'sidebar-link',
    to: '/tokens',
    name: 'Opportunities',
    icon_feather: 'eye',
    requiresAuth: false,
  },
  {
    list_class: 'sidebar-item',
    link_class: 'sidebar-link',
    to: '/user/account',
    icon_feather: 'user',
    name: 'User',
    requiresAuth: true,
  },
  /*
  {
    list_class: 'sidebar-item',
    link_class: 'sidebar-link',
    to: '/buttons',
    icon_feather: 'message-square',
    name: 'Buttons',
  },
  {
    list_class: 'sidebar-item',
    link_class: 'sidebar-link',
    to: '/cards',
    icon_feather: 'message-square',
    name: 'Cards',
  },
  {
    list_class: 'sidebar-item',
    link_class: 'sidebar-link',
    to: '/spinner',
    icon_feather: 'message-square',
    name: 'Spinner',
  },
  {
    list_class: 'sidebar-item',
    link_class: 'sidebar-link',
    to: '/alerts',
    icon_feather: 'message-square',
    name: 'Alerts',
  },*/
];
